import { RouteLocation, RouteRecord } from 'vue-router';

import i18n from '@/dependencies/i18n';
import { useApplicationStore } from '@/stores/application.store';

const { t } = i18n.global;

const pageMetadataService = {
    getMatch(matched: any) {
        return matched
            .slice()
            .reverse()
            .find((r: { meta: { title: any } }) => r.meta && r.meta.title);
    },

    getTitle(matched: RouteRecord[], addition?: string | undefined): string {
        const applicationStore = useApplicationStore();
        const closestTitle = this.getMatch(matched);
        const tenancyName = applicationStore.info?.tenant?.name ?? 'Firm24';

        let title;

        if (closestTitle) {
            title = `${t('PAGE_TITLES.' + closestTitle.meta.title)} | ${tenancyName}`;
        } else {
            title = tenancyName;
        }

        return addition ? `${addition} | ${title}` : title;
    },

    setDefaultPageTitle(to: RouteLocation): void {
        const closestTitle = this.getMatch(to.matched);

        if (closestTitle) {
            document.title = this.getTitle(to.matched);
        }
    },

    setPageTitle(to: RouteLocation, addition?: string): void {
        document.title = this.getTitle(to.matched, addition as string);
    },
};

export default pageMetadataService;
